import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import api from '../services/api';
import SiteNavbar from './SiteNavbar';
import SiteFooter from './SiteFooter';
import ProductCard from './ProductCard';

export default function SearchResults() {
  const [searchParams] = useSearchParams();
  const termo = (searchParams.get('q') || '').trim();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    if (!termo) {
      setProducts([]);
      setLoading(false);
      return;
    }

    let ativo = true;
    setLoading(true);
    setErro(false);

    api.get('/products', { params: { search: termo } })
      .then(res => {
        if (ativo) setProducts(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => {
        if (ativo) { setProducts([]); setErro(true); }
      })
      .finally(() => {
        if (ativo) setLoading(false);
      });

    return () => { ativo = false; };
  }, [termo]);

  const total = products.length;

  return (
    <div>
      <SiteNavbar />

      <Container className="mt-4">
        <h2 className="mb-1">
          {termo ? <>Resultados para “{termo}”</> : 'Buscar produtos'}
        </h2>

        {!loading && !erro && termo && (
          <p className="text-muted mb-4">
            {total === 0
              ? 'Nenhum produto encontrado.'
              : `${total} produto${total > 1 ? 's' : ''} encontrado${total > 1 ? 's' : ''}.`}
          </p>
        )}

        {!termo && (
          <p className="text-muted mb-4">
            Digite o nome de um produto no campo de busca acima.
          </p>
        )}

        {loading && <p className="text-muted">Buscando produtos...</p>}

        {erro && (
          <p className="text-muted">
            Não foi possível realizar a busca agora. Tente novamente em instantes.
          </p>
        )}

        {!loading && !erro && termo && total === 0 && (
          <p className="text-muted">
            Confira a grafia ou tente um termo mais curto.{' '}
            <Link to="/" className="text-decoration-none">Ver todos os produtos →</Link>
          </p>
        )}

        {total > 0 && (
          <Row xs={1} sm={2} md={3} lg={4} className="g-4">
            {products.map(produto => (
              <Col key={produto._id}>
                <ProductCard produto={produto} />
              </Col>
            ))}
          </Row>
        )}
      </Container>

      <SiteFooter />
    </div>
  );
}
